import { render, staticRenderFns } from "./UserPropertyMenu.vue?vue&type=template&id=4a729e1e&scoped=true"
import script from "./UserPropertyMenu.vue?vue&type=script&lang=js"
export * from "./UserPropertyMenu.vue?vue&type=script&lang=js"
import style0 from "./UserPropertyMenu.vue?vue&type=style&index=0&id=4a729e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a729e1e",
  null
  
)

export default component.exports